

const Contact = ({ contact }) => {
  const { title, id } = contact;
  return (
    <div className="mx-2" key={id}>
        
          <p> {title} ,</p>
        
     
    </div>
  );
};

export default Contact;
